import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { getDenominationFieldError } from "./discountUtils";

export default function DenominationTable({
  rows,
  discountType,
  errors = {},
  onChange,
  loading = false,
  disabled = false,
}) {
  if (loading) {
    return <Typography color="text.secondary">Loading denominations...</Typography>;
  }

  if (!rows?.length) {
    return (
      <Typography color="text.secondary">
        Select a SKU to load denomination rows.
      </Typography>
    );
  }

  const handleRowChange = (index, field, value) => {
    const next = rows.map((row, i) => {
      if (i !== index) return row;
      const updated = { ...row, [field]: value };
      if (field === "discount_percent" && discountType === "fixed") {
        updated.max_discount_percent = value;
      }
      return updated;
    });
    onChange(next);
  };

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Denomination (₹)</TableCell>
            <TableCell>Discount %</TableCell>
            <TableCell>Max discount %</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={row.denomination}>
              <TableCell>₹{row.denomination}</TableCell>
              <TableCell>
                <TextField
                  type="number"
                  size="small"
                  value={row.discount_percent}
                  onChange={(e) =>
                    handleRowChange(index, "discount_percent", e.target.value)
                  }
                  error={Boolean(getDenominationFieldError(errors, index, "discount_percent"))}
                  helperText={getDenominationFieldError(errors, index, "discount_percent")}
                  inputProps={{ min: 0, max: 100, step: "0.01" }}
                  disabled={disabled}
                  sx={{ minWidth: 120 }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  size="small"
                  value={row.max_discount_percent}
                  onChange={(e) =>
                    handleRowChange(index, "max_discount_percent", e.target.value)
                  }
                  error={Boolean(getDenominationFieldError(errors, index, "max_discount_percent"))}
                  helperText={getDenominationFieldError(errors, index, "max_discount_percent")}
                  inputProps={{ min: 0, max: 100, step: "0.01" }}
                  disabled={disabled || discountType === "fixed"}
                  sx={{ minWidth: 120 }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
